import React, { useState } from 'react'
    import { ChevronDown, ChevronUp } from 'lucide-react'

    const FAQSection = () => {
      const [openFAQ, setOpenFAQ] = useState(null)

      const faqs = [
        {
          question: "Do I need good credit to get funding?",
          answer: "No! We specialize in alternative and subprime lending solutions. We work with private lenders, hard money lenders, and credit unions that focus on business cash flow, assets, and potential rather than just credit scores. Many of our clients have poor credit or no credit history."
        },
        {
          question: "How fast can I get funding?",
          answer: "Our typical approval process is 48-72 hours for most alternative lending programs. Hard money loans can close in as little as 7-14 days. Traditional bank alternatives may take 2-4 weeks, but still much faster than conventional bank loans."
        },
        {
          question: "What documents do I need?",
          answer: "Basic requirements include: business registration (EIN), bank statements (3-6 months), Certificate of Insurance (COI) if applicable, and basic business information. We help you prepare and package everything professionally to maximize approval chances."
        },
        {
          question: "Do you work with new businesses?",
          answer: "Yes! We have startup funding packages and work with lenders who specialize in new businesses. Even if you have no revenue history, we can help through asset-based lending, equipment financing, and startup-friendly alternative lenders."
        },
        {
          question: "Do you charge upfront fees?",
          answer: "We work on a success-based model. Our fees are typically paid at closing when you receive your funding. We believe in earning our compensation by delivering results, not charging upfront fees before securing your capital."
        },
        {
          question: "What makes Nomadic Solutions different from other brokers?",
          answer: "We specialize in 'impossible' cases - businesses that banks reject. Our network includes subprime lenders, private capital sources, and alternative financing that most brokers don't have access to. We also provide COI optimization, strategic packaging, and post-funding growth planning."
        }
      ]

      const toggleFAQ = (index) => {
        setOpenFAQ(openFAQ === index ? null : index)
      }

      return (
        <section className="py-20 bg-white" data-component-path="client/src/components/FAQSection.jsx" data-component-line="1:4" data-component-id="client/src/components/FAQSection.jsx:1:4">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/FAQSection.jsx" data-component-line="2:6" data-component-id="client/src/components/FAQSection.jsx:2:6">
            <div className="text-center mb-12" data-component-path="client/src/components/FAQSection.jsx" data-component-line="3:8" data-component-id="client/src/components/FAQSection.jsx:3:8">
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-component-path="client/src/components/FAQSection.jsx" data-component-line="4:10" data-component-id="client/src/components/FAQSection.jsx:4:10">
                Frequently Asked Questions
              </h2>
              <p className="text-lg text-gray-700" data-component-path="client/src/components/FAQSection.jsx" data-component-line="5:10" data-component-id="client/src/components/FAQSection.jsx:5:10">
                Get answers to common questions about our business loan brokerage services
              </p>
            </div>

            <div className="space-y-4" data-component-path="client/src/components/FAQSection.jsx" data-component-line="6:8" data-component-id="client/src/components/FAQSection.jsx:6:8">
              {faqs.map((faq, index) => (
                <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-component-path="client/src/components/FAQSection.jsx" data-component-line="7:12" data-component-id="client/src/components/FAQSection.jsx:7:12">
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center"
                    data-component-path="client/src/components/FAQSection.jsx" data-component-line="8:14" data-component-id="client/src/components/FAQSection.jsx:8:14"
                  >
                    <span className="font-semibold text-black" data-component-path="client/src/components/FAQSection.jsx" data-component-line="9:16" data-component-id="client/src/components/FAQSection.jsx:9:16">{faq.question}</span>
                    {openFAQ === index ? (
                      <ChevronUp className="text-gold" size={24} />
                    ) : (
                      <ChevronDown className="text-gold" size={24} />
                    )}
                  </button>
                  {openFAQ === index && (
                    <div className="px-6 py-4 bg-white" data-component-path="client/src/components/FAQSection.jsx" data-component-line="10:16" data-component-id="client/src/components/FAQSection.jsx:10:16">
                      <p className="text-gray-700 leading-relaxed" data-component-path="client/src/components/FAQSection.jsx" data-component-line="11:18" data-component-id="client/src/components/FAQSection.jsx:11:18">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )
    }

    export default FAQSection